import { WagakoApiBase } from './wagakoApiBase';

import type {
  AppApiSpecialDataDelete,
  AppApiSpecialErrorReportCreate,
  AppApiSpecialUserUpdate,
  AppApiSpecialFacilityUpdate,
} from './wagakoAppApiTypes';
import type { WagakoAppIApi } from './wagakoAppIApi';

import { apiWagakoAppUrl, isDebug } from '@/constants/env';

/**
 * WagakoAppApi
 */
export class WagakoAppApi extends WagakoApiBase implements WagakoAppIApi {
  /** API URL */
  protected get apiUrl(): string {
    return apiWagakoAppUrl;
  }

  /**
   * 削除データ
   * @param data データ
   * @returns レスポンス
   */
  async deleteData(data: AppApiSpecialDataDelete.Request.BodyDataType) {
    const response = await this.callApi<
      AppApiSpecialDataDelete.Request.Type,
      AppApiSpecialDataDelete.Response.Type
    >({
      path: '/app/special/data',
      method: 'delete',
      body: { data },
    });
    return response;
  }

  /**
   * エラーレポート
   * @param data データ
   * @returns レスポンス
   */
  async errorReport(data: AppApiSpecialErrorReportCreate.Request.BodyDataType) {
    if (isDebug) {
      // eslint-disable-next-line no-console
      console.error(data);
      return { message: 'OK' } as AppApiSpecialErrorReportCreate.Response.Type;
    }
    const response = await this.callApi<
      AppApiSpecialErrorReportCreate.Request.Type,
      AppApiSpecialErrorReportCreate.Response.Type
    >({
      path: '/app/special/error-report',
      method: 'put',
      body: { data },
    });
    return response;
  }

  /**
   * ユーザー更新
   * @param data データ
   * @returns レスポンス
   */
  async updateUser(data: AppApiSpecialUserUpdate.Request.BodyDataType) {
    const response = await this.callApi<
      AppApiSpecialUserUpdate.Request.Type,
      AppApiSpecialUserUpdate.Response.Type
    >({
      path: '/app/special/user',
      method: 'post',
      body: { data },
    });
    return response;
  }

  /**
   * 施設更新
   * @param data データ
   * @returns レスポンス
   */
  async updateFacility(data: AppApiSpecialFacilityUpdate.Request.BodyDataType) {
    const response = await this.callApi<
      AppApiSpecialFacilityUpdate.Request.Type,
      AppApiSpecialFacilityUpdate.Response.Type
    >({
      path: '/app/special/childfacility',
      method: 'post',
      body: { data },
    });
    return response;
  }
}
